import { c as _c } from "react-compiler-runtime";
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Flex } from 'foundations-components/components/Flex';
import { ErrorMessage as FoundationsErrorMessage } from 'foundations-components/transitional/components/ErrorMessage';
import { jsx as _jsx } from "react/jsx-runtime";
export default function ErrorMessage(t0) {
  "use memo";

  const $ = _c(7);
  const {
    title,
    message,
    type,
    illustration
  } = t0;
  let t1;
  if ($[0] !== message) {
    t1 = message ? /*#__PURE__*/_jsx("p", {
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: message
      })
    }) : null;
    $[0] = message;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== illustration || $[3] !== t1 || $[4] !== title || $[5] !== type) {
    t2 = /*#__PURE__*/_jsx(Flex, {
      flexDirection: "row",
      alignItems: "center",
      blockSize: "100%",
      children: /*#__PURE__*/_jsx(FoundationsErrorMessage, {
        type: type,
        title: title,
        illustration: illustration,
        children: t1
      })
    });
    $[2] = illustration;
    $[3] = t1;
    $[4] = title;
    $[5] = type;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  return t2;
}